module.exports = __webpack_public_path__ + "img/imgSrc111.5f6df036.png";